import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const SideBar = () => (
  <section id="sidebar">
    <section className="blurb">
      <h2>About</h2>
      <p>
        Hi, I&apos;m Timothy. I am a Belmont University graduate, programmer,
        web developer and Cloud Architect. Proud business owner and Entreprenuer.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? (
            <Link to="/resume" className="button">
              Learn More
            </Link>
          ) : (
            <Link to="/about" className="button">
              About Me
            </Link>
          )}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">
        &copy; Timothy Demonbreun <Link to="/">timothyd.site</Link>.
      </p>
    </section>
  </section>
);

export default SideBar;
